(ns teamoesterreich.admin-mode.detail-filter.lebensretter-filter
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]))

(def LR_QUALIFICATION {
                       "16EH" "Erste Hilfe Kurs (8h)"
                       "CPR"  "Wiederbelebungstraining"
                       "RS"   "Aktiver Rettungsdienst"
                       "NA"   "Arzt / Notarzt"
                       "IPF"  "Intensiv-Pflegepersonal"
                       })



(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))

(defn wait-do-check [!waiting? !loaded? event-fn]
  (fn [e val]
    (js/console.log "wait or do" val)
    (event-fn val)
    (reset! !waiting? false)
    (reset! !loaded? false)))

(defn wait-do-select [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false))))


(defn check-box [!waiting? !loaded? !detail-search name add-filter-key]

  [mui/form-control-label {:label   name :value "dst" :placement "start"
                           :control (r/as-element [mui/checkbox {:checked  (get @!detail-search add-filter-key)
                                                                 :onChange (wait-do-check !waiting? !loaded? (fn [val] (swap! !detail-search assoc add-filter-key val)))
                                                                 }])}]

  )



(defn lebensretter-block [!detail-search !waiting? !loaded?]
  [mui/grid
   {:item  true
    :xs    12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "flex-start"
      :spacing    1
      :style      {:padding "5px"}
      }

     [mui/grid
      {:item true
       :lg   2
       :md   3
       :xs   6
       }
      [mui/typography "Lebensretter"]
      ]
     [mui/grid
      {:item true
       :md   3
       :xs   6
       }

      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}


        [check-box !waiting? !loaded? !detail-search "Will Lebensretter" :filter-lebensretter]
        [check-box !waiting? !loaded? !detail-search "Freigeschaltet LR" :filter-lebensretterActive]]]]
     [mui/grid
      {:item true
       :md   2
       :xs   3
       }
      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Angemeldet von")
                       :onChange        (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-lrSince-from val)))
                       :defaultValue    (:filter-lrSince-from @!detail-search)
                       }]
      ]
     [mui/grid
      {:item true
       :md   2
       :xs   3
       }
      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Angemeldet bis")
                       :onChange        (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-lrSince-to val)))
                       :defaultValue    (:filter-lrSince-to @!detail-search)
                       }]
      ]
     [mui/grid
      {:item true
       :md   2
       :xs   6
       }
      ]

     [mui/grid
      {:item true
       :lg   2
       :md   3
       :xs   6
       }
      ]
     [mui/grid
      {:item true
       :md   3
       :xs   6
       }

      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}
        (when (d-rights/allow-admin-for d-rights/FIRST_RESPONDER)
          [check-box !waiting? !loaded? !detail-search "Freigeschaltet FR" :filter-firstResponderActive])

        ;[check-box !waiting? !loaded? !detail-search "Datenherkunft" :filter-lrSource]
        [check-box !waiting? !loaded? !detail-search "Hatte Einsätze" :filter-lebensretterHasInterventions]]
       ]]

     [mui/grid
      {:item true
       :md   2
       :xs   3
       }
      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Freischaltungsende von")
                       :onChange        (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-lr-clearance-from val)))
                       :defaultValue    (:filter-lr-clearance-from @!detail-search)
                       }]
      ]
     [mui/grid
      {:item true
       :md   2
       :xs   3
       }
      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Freischaltungsende bis")
                       :onChange        (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-lr-clearance-to val)))
                       :defaultValue    (:filter-lr-clearance-to @!detail-search)
                       }]
      ]
     [mui/grid
      {:item true
       :md   2
       :xs   6
       }
      [mui/form-control
       {
        :style     {:maxWidth "500px"}
        :fullWidth true
        }
       [mui/input-label "Freischaltungsart"]
       [mui/select
        {:multiple true
         :value    (or (:filter-lr-qualification-type @!detail-search) [])
         :onChange (wait-do-select !waiting? !loaded? (fn [val]
                                                        (swap! !detail-search assoc :filter-lr-qualification-type val)
                                                        ))
         }
        [mui/menu-item {:key (str "jobstatus_all") :value ""} "-"]
        (for [[key name] LR_QUALIFICATION]
          [mui/menu-item {:key (str "jobstatus_" key) :value key} name])

        ]]]
     ]

    ]])
